import React from 'react'

import { useState } from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'

// import 'react-spring-bottom-sheet/dist/style.css'

import '../rbs.css'


export default function PaymentFAB() {


    const [open, setOpen] = useState(false);

    const onDismiss = () => {
        setOpen(false)
    
        
      }


  return (
    <div className='w-full flex justify-center hover:cursor-pointer'>

    <div onClick={() => setOpen(true)} className='flex items-center gap-1 fixed  text-sm bottom-20 p-3 px-5 rounded-full bg-[#007A5D] hover:bg-teal-700 duration-300'>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z" fill="#fff"/>
<path d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z" fill="#fff"/>
</svg>
 New payment
    </div>


    <BottomSheet
    
          open={open}
          onDismiss={onDismiss}
        //   snapPoints={({ minHeight, maxHeight }) => ["800px", "100px"]}
        snapPoints={({ minHeight}) => [330]}
        skipInitialTransition={true}
        
        
        >
          <div className="containerx pt-10 text-white">
    <h2 className="text-2xl font-bold pb-5 ">New payment</h2>
    <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
        <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
    <button className="w-full bg-[#007A5D] hover:bg-teal-900 duration-300 p-3 text-white rounded-md">sub</button>
  </div>
        </BottomSheet>


    </div>
  )
}
